import { errors } from "../../../errors/errors";
import { Translations } from "./types";

export const translations = {
  "notification.saved": {
    en: "Saved",
    sk: "Uložené",
    ko: "저장",
  },
  "notification.saved.description.confirmed.singular": {
    en: "🥳 Yay! We can't wait to see you there!",
    sk: "🥳 Hurá! Tešíme sa na teba.",
    ko: "🥳 오예! 얼른 뵙고 싶어요!",
  },
  "notification.saved.description.confirmed.plural": {
    en: "🥳 Yay! We can't wait to see you there!",
    sk: "🥳 Hurá! Tešíme sa na vás.",
    ko: "🥳 오예! 얼른 뵙고 싶어요!",
  },
  "notification.saved.description.declined": {
    en: "No worries! If you change your mind, you can update your RSVP until June 1.",
    sk: "To je škoda, ale nevadí. Ak by sa niečo zmenilo, svoju odpoveď môžeš do 1. júla zmeniť.",
    ko: "아이고, 아쉽지만 다음에 만나요! 마음이 바뀌시면 6월 1일까지 참석여부 업데이트 가능합니다.",
  },
  "notification.dismiss": {
    en: "Dismiss",
    sk: "Skryť",
    ko: "닫기",
  },
  "notification.close": {
    en: "Close",
    sk: "Zavrieť",
    ko: "닫기",
  },
  "common.optional": {
    en: "Optional",
    sk: "Nepovinné",
    ko: "선택사항",
  },
  "eventCountdown.days_plural": {
    en: "DAYS",
    sk: "DNÍ",
    ko: "일",
  },
  "eventCountdown.days_singular": {
    en: "DAY",
    sk: "DEŇ",
    ko: "일",
  },
  "eventCountdown.days_2_4": {
    en: "DAYS",
    sk: "DNI",
    ko: "일",
  },
  "eventCountdown.hours_plural": {
    en: "HOURS",
    sk: "HODÍN",
    ko: "시간",
  },
  "eventCountdown.hours_singular": {
    en: "HOUR",
    sk: "HODINA",
    ko: "시간",
  },
  "eventCountdown.hours_2_4": {
    en: "HOURS",
    sk: "HODINY",
    ko: "시간",
  },
  "eventCountdown.minutes_plural": {
    en: "MINUTES",
    sk: "MINÚT",
    ko: "분",
  },
  "eventCountdown.minutes_singular": {
    en: "MINUTE",
    sk: "MINÚTA",
    ko: "분",
  },
  "eventCountdown.minutes_2_4": {
    en: "MINUTES",
    sk: "MINÚTY",
    ko: "분",
  },
  "home.title": {
    en: "Robert & Bowon",
    sk: "Robert & Bowon",
    ko: "로보 & 보원",
  },
  "home.weddingDay": {
    en: "Saturday",
    sk: "Sobota",
    ko: "토요일",
  },
  "home.weddingDate": {
    en: "July 12, 2025",
    sk: "12. júla, 2025",
    ko: "2025년 7월 12일",
  },
  "home.weddingLocation": {
    en: "Zdiar, Slovakia",
    sk: "Ždiar, Slovensko",
    ko: "쥬디알, 슬로바키아",
  },
  "home.rsvp": {
    en: "RSVP",
    sk: "Odpovedať",
    ko: "참석여부 전하기",
  },
  "home.attending.yes.singluar": {
    en: "You Are Attending",
    sk: "Zúčastním sa",
    ko: "참석합니다",
  },
  "home.attending.yes.plural": {
    en: "You Are Attending",
    sk: "Zúčastníme sa",
    ko: "참석합니다",
  },
  "home.attending.no": {
    en: "You Are Not Attending",
    sk: "Nezúčastním sa",
    ko: "참석하지 못합니다",
  },
  "home.hello": {
    en: "Hello",
    sk: "Ahoj",
    ko: "안녕하세요",
  },
  "home.notYou.singular": {
    en: "Not you?",
    sk: "Nie si to ty?",
    ko: "본인이 아닌가요?",
  },
  "home.notYou.plural": {
    en: "Not you?",
    sk: "Nie ste to vy?",
    ko: "본인이 아닌가요?",
  },
  "home.viewDetails": {
    en: "View Details",
    sk: "Prejdi na detaily",
    ko: "자세한 내용 보기",
  },
  "home.story.title": {
    en: "Story",
    sk: "Príbeh",
    ko: "우리의 이야기",
  },
  "home.story.content_1": {
    en: "Bowon and Robert met while working at Cloudflare in San Francisco. They were on different teams, but fate (and free snacks at company events) kept bringing them together. One day they discovered they both lived in North Beach, and just like that, a daily walking commute was born. The walk home was the perfect length for Bowon to flex her gym gains and recount whatever bizarre dream her subconscious cooked up the night before. Robert, ever the problem-solving wizard, would chime in with fitness tips and suspiciously detailed dream interpretations—equal parts personal trainer and part-time dream shaman.",
    sk: "Bowon a Robo sa spoznali, keď pracovali v Cloudflare v San Franciscu. Aj keď neboli v jednom tíme, osud (a firemné akcie s jedlom zdarma) ich stále spájal. Po čase zistili, že obaja bývajú v North Beach časti mesta, a tak sa zrodil ich každodenný spoločný peší presun domov. Cesta bola akurát dlhá na to, aby sa Bowon mohla pochváliť pokrokmi z posilňovne a porozprávať o tom, aký bizarný sen jej podvedomie v noci vymyslelo. Robo, ako rodený riešiteľ problémov, sa rád pridal s tipmi na cvičenie a podozrivo dôkladnými výkladmi snov — napoly osobný tréner, napoly šaman na sny.",
    ko: "보원과 로버트는 샌프란시스코에 있는 클라우드플레어에서 일하면서 처음 만났습니다. 서로 다른 팀에서 일했지만, 운명(그리고 회사 행사에서 나오는 무료 간식)이 계속해서 둘을 엮어주었죠. 그러다 어느 날, 둘 다 노스 비치에 산다는 사실을 알게 되었고, 그렇게 자연스럽게 매일 함께 걷는 퇴근길이 시작되었습니다. 집까지 가는 길은 보원이 헬스장에서 쌓은 근육을 뽐내고, 전날 밤에 꾼 기묘한 꿈 이야기를 들려주기에 딱 알맞은 거리였죠. 문제 해결의 마법사인 로버트는 언제나처럼 운동 팁과 수상할 정도로 디테일한 꿈해몽을 곁들여 대화를 이어갔습니다 — 반은 퍼스널 트레이너, 반은 점쟁이처럼요.",
  },
  "home.story.content_2": {
    en: "Then came the fateful moment—Bowon invited Robert to her birthday party. One thing led to another and the rest is history.",
    sk: "Osudný moment prišiel, keď Bowon pozvala Roba na jej narodeninovú oslavu. Jedna vec viedla k druhej a zvyšok je história.",
    ko: "그러다 운명의 순간이 찾아왔죠! 보원은 로보를 생일파티에 초대했고... 그 후의 이야기는 안봐도 뻔하죠?",
  },
  "home.story.content_3": {
    en: "Shortly after COVID-19 hit, they decided to quarantine in style by moving in together. Fast forward to a tropical day in Wailea, Maui: Robert proposed under the Hawaiian sun, and Bowon said yes! And now they are planning their wedding.",
    sk: "Krátko po tom, čo začal COVID-19, sa obaja rozhodli pre spoločnú karanténu v novom byte. O pár rokov neskôr pod havajským slnkom vo Wailea, Maui, Robo požiadal Bowon o ruku a Bowon povedala áno! A tak teraz plánujú ich svadbu.",
    ko: "코로나 이후에는 자가격리 하는 김에, 폼나게 둘이 같이 살기로 했답니다. 그렇게 시간이 흘러, 하와이 마우이섬의 와일레아에서 로보는 하와이의 뜨거운 석양 아래에서 프로포즈를 했고 보원은 Yes!를 외쳤답니다. 그 후로부터 둘은 결혼식을 준비하는 중입니다",
  },
  "home.story.content_4": {
    en: "And you're invited!",
    sk: "A pozývajú vás!",
    ko: "그리하여 여러분을 둘의 결혼에 초대합니다!",
  },
  "home.tidbits.title": {
    en: "Tidbits",
    sk: "Pikošky",
    ko: "소소한 사실들",
  },
  "home.tidbits.question_1": {
    en: "How did you first meet?",
    sk: "Ako ste sa spoznali?",
    ko: "둘은 어떻게 만났나요?",
  },
  "home.tidbits.answer_1": {
    en: "We worked at Cloudflare in San Francisco together.",
    sk: "Obaja sme pracovali v Cloudflare v San Franciscu.",
    ko: "저희는 샌프란시스코에 위치한 클라우드플레어에서 함께 근무했어요.",
  },
  "home.tidbits.question_2": {
    en: "Who's going to vacuum the house? What if they don't?",
    sk: "Kto bude vysávať? A čo keď nebude?",
    ko: "청소기는 누가 돌리나요? ",
  },
  "home.tidbits.answer_2": {
    en: "Robert, obviously, because Bowon is a princess and vacuum cleaner is too heavy.",
    sk: "Samozrejme, že Robo, pretože Bowon je princezná a vysávač je veľmi ťažký.",
    ko: "보원은 공주님이라서 청소기는 무겁대요. 그래서 로보가 돌려요.",
  },
  "home.tidbits.question_3": {
    en: "What is your favorite activity together?",
    sk: "Aká je vaša obľúbená spoločná aktivita?",
    ko: "둘이서 같이 무엇을 즐겨하나요?",
  },
  "home.tidbits.answer_3": {
    en: "Becoming MasterChefs in our own kitchen—or letting a restaurant do the hard work for us. Traveling the world like curious explorers (who require frequent snack breaks). And, of course, watching movies with a fine glass of wine or a beer, because Korean drama is best enjoyed slightly tipsy.",
    sk: "Hrať sa na MasterChef šéfkuchárov v našej kuchyni, alebo to prenechať dobrej reštaurácii. Cestovať po svete ako objavitelia (ktorí potrebujú časté prestávky na občerstvenie). A samozrejme, sledovanie filmov s pohárom dobrého vína alebo piva, pretože filmovú drámu si najlepšie vychutnáte mierne opití.",
    ko: "집에서 요리왕 놀이를 하거나 나가서 맛있는 식사를 같이 하는걸 좋아해요. 세상이 궁금한 탐험가처럼 여행하고 맛집 탐방도 하고, 와인이나 맥주 한잔에 알딸딸하게 영화나 한국 드라마 보는걸 좋아합니다.",
  },
  "home.tidbits.question_4": {
    en: "Did you learn each other's language?",
    sk: "Naučili ste sa vaše rodné jazyky?",
    ko: "서로의 언어는 마스터했나요?",
  },
  "home.tidbits.answer_4": {
    en: `Not quite... but we're getting there! Robert can write in Hangul (even if he doesn’t always know what he’s writing), and Bowon has mastered the most important Slovak phrase: "Som hladná" (I'm hungry).`,
    sk: `Nie celkom... ale snažíme sa. Robo už vie kórejskú abecedu (aj keď nie vždy vie, čo píše), a Bowon ovláda najdôležitejšiu slovenskú frázu: "Som hladná".`,
    ko: "그닥 잘하진 않지만 공부하고 있습니다! 로보는 한글로 쓸수 있고 (그렇다고 뜻을 아는건 아니지만ㅎㅎ), 보원은 제일 중요한 Som hladná (배고파)를 마스터했습니다.",
  },
  "home.tidbits.question_5": {
    en: "What language will your children speak?",
    sk: "Akým jazykom budú hovoriť vaše deti?",
    ko: "아이가 생기면 무슨 언어로 말할까요?",
  },
  "home.tidbits.answer_5": {
    en: "A mix of Slovak, Korean, and English—basically, they'll be trilingual geniuses who can order food in three languages but still pretend they didn’t understand us when we ask them to clean their room!",
    sk: "Mix slovenčiny, kórejčiny, a angličtiny. V podstate to budú trojjazyční géniovia, ktorí si budú vedieť objednať jedlo v troch jazykoch, a zároveň predstierať, že nám nerozumejú, keď im povieme, aby si upratali izbu!",
    ko: "아마 슬로박, 한국어, 영어 3개 국어 천재 아니면 0개 국어? 배고플 땐 3개 국어 천재가 되고 청소시키면 못 알아 듣는 척하는 0개 국어가 될 것 같아요.",
  },
  "home.tidbits.question_6": {
    en: "What is the best meal you have eaten together?",
    sk: "Najlepšie jedlo, aké ste spolu mali?",
    ko: "같이 먹은 음식 중 가장 맛있었던 음식은 무엇인가요?",
  },
  "home.tidbits.answer_6": {
    en: "Traditional Korean BBQ in San Ho Won restaurant in San Francisco.",
    sk: "Tradičné kórejské BBQ v reštraurácii San Ho Won v San Franciscu.",
    ko: "샌프란시스코에 있는 산호원이라는 미슐랭 한식 고깃집이요.",
  },
  "home.tidbits.question_7": {
    en: "What is the most memorable trip you have taken together?",
    sk: "Najpamätnejší výlet, na ktorý ste šli spolu?",
    ko: "가장 기억에 남는 여행은 언제인가요?",
  },
  "home.tidbits.answer_7": {
    en: "In 2021, we took a road trip across the United States, from San Francisco to New York and back. We drove roughly 8 thousand miles over 40 days and our favorite stops were Death Valley, Las Vegas, Grand Canyon, New York, Niagara Falls, and Yellowstone.",
    sk: "V roku 2021 sme šli autom naprieč Amerikou, zo San Francisca do New Yorku a naspäť. Za 40 dní sme odšoférovali zhruba 13 tisíc kilometrov a naše obľubené zastávky boli Údolie smrti (Death Valley), Las Vegas, Veľký kaňon (Grand Canyon), New York, Niagarské vodopády (Niagara Falls), a Yellowstone.",
    ko: "2021년에 40일간 1만 3천 킬로미터를 달려서 샌프란시스코에서 뉴욕까지 왕복 로드트립을 했습니다. 그중 최애는 캘리포니아 데스벨리, 라스베가스, 그랜드캐니언, 뉴욕 맨하탄, 나이아가라 폭포, 옐로스톤 국립공원!",
  },
  "home.tidbits.question_8": {
    en: "What nicknames do you have for each other?",
    sk: "Ako sa navzájom voláte?",
    ko: "서로를 어떻게 부르나요? 애칭이 있나요?",
  },
  "home.tidbits.answer_8": {
    en: `"Bobky" and "Robky".`,
    sk: `"Bobky" a "Robky".`,
    ko: "봅키 & 롭키",
  },
  "home.schedule.title": {
    en: "Schedule",
    sk: "Program",
    ko: "스케줄",
  },
  "home.schedule.saturday.event1.day": {
    en: "Saturday, July 12, 2025",
    sk: "Sobota, 12. júla, 2025",
    ko: "2025년 7월 12일 토요일",
  },
  "home.schedule.saturday.event1.time": {
    en: "3:00 PM to 4:00 PM",
    sk: "Od 15:00 do 16:00",
    ko: "오후 3시부터 4시까지",
  },
  "home.schedule.saturday.event1.title": {
    en: "Wedding Ceremony",
    sk: "Svadobný obrad",
    ko: "본식",
  },
  "home.schedule.saturday.event1.description": {
    en: "We're getting married. Don't be late!",
    sk: "Budeme sa brať. Nemeškať!",
    ko: "본식에 늦지 말아주세요!",
  },
  "home.schedule.saturday.event1.location": {
    en: "Medvedi brloh Strachan, Zdiar, Slovakia",
    sk: "Medvedí brloh Strachan, Ždiar, Slovensko",
    ko: "메드베디 브를로흐 스트라한, 쥬디알, 슬로바키아",
  },
  "home.schedule.saturday.event2.time": {
    en: "4:00 PM to 3:00 AM",
    sk: "Od 16:00 do 03:00",
    ko: "오후 4시부터 다음날 새벽 3시까지",
  },
  "home.schedule.saturday.event2.title": {
    en: "Wedding Reception",
    sk: "Svadobná hostina a párty",
    ko: "피로연 파티",
  },
  "home.schedule.saturday.event2.description": {
    en: "It's dinner and party time! We encourage everyone to grab some drinks and get out on the dance floor. Don't be shy. We are all family and friends.",
    sk: "Čas na večeru a párty! Odporúčame všetkým, aby si dali nejaké drinky a vyšli na tanečný parket. Nehanbiť sa. Všetci sme rodina a priatelia.",
    ko: "피로연은 저녁 식사와 댄스 파티가 있을 예정입니다. 수줍어 말고 전부 가족과 친구이니까 한잔 하면서 밤새 흔들어봅시다! ",
  },
  "home.schedule.toBeAnnounced": {
    en: "To Be Announced",
    sk: "Upresníme neskôr",
    ko: "곧 공지할 내용들",
  },
  "home.schedule.toBeAnnounced.event1.title": {
    en: "Shuttle from/to Budapest International Airport",
    sk: "Autobus z letiska v Budapešti a naspäť",
    ko: "부다페스트 공항 셔틀버스",
  },
  "home.schedule.toBeAnnounced.event1.description": {
    en: "Shuttle will be available on Thursday before wedding and Monday after wedding. We will share exact time at a later date.",
    sk: "Autobus bude dostupný v štvrtok pred svadbou a v pondelok po svadbe. Presný čas upresníme neskôr.",
    ko: "7월 10일 목요일 저녁에 부다페스트에서 픽업하고, 14일 월요일에 체크아웃 후 부다페스트행 셔틀버스가 있을 예정입니다.",
  },
  "home.faq.title": {
    en: "Q & A",
    sk: "Často kladené otázky",
    ko: "Q & A",
  },
  "home.faq.question_1": {
    en: "What will I wear?",
    sk: "Čo si mám obliecť?",
    ko: "드레스코드는 어떻게 되나요?",
  },
  "home.faq.answer_1": {
    en: 'Dress code is semi-formal, so somewhere between "I have my life together" and "I tried, okay?"',
    sk: `Dress kód je poloformálny, takže niečo medzi "Mám svoj život pokope" a "Snažil som sa, dobre?"`,
    ko: "세미 정장 및 깔끔한 이브닝 드레스나 투피스면 됩니다.",
  },
  "home.faq.question_2": {
    en: "When is the RSVP deadline?",
    sk: "Koľko mám času na odpoveď?",
    ko: "참석 여부는 언제까지 제출하면 되나요?",
  },
  "home.faq.answer_2": {
    en: "It would be sweet if you could RSVP by June 1, so we can get an accurate headcount.",
    sk: "Bolo by super, ak by si odpovedal(a) do 1. júna, pretože potrebujeme presný počet hostí pár týžňov dopredu.",
    ko: "정확한 인원수 계산을 위해서 6월 1일까지 알려주시면 감사하겠습니다.",
  },
  "home.faq.question_3": {
    en: "Can I bring a date?",
    sk: "Môžem prísť s partnerkou/partnerom?",
    ko: "파트너를 데려와도 되나요?",
  },
  "home.faq.answer_3": {
    en: "You can bring your +1, but make sure to add their name in your RSVP so we can count with them!",
    sk: "Áno, ale nezabudni ich pridať a vyplniť ich meno v tvojej odpovedi, aby sme s nimi počítali.",
    ko: "네, 파트너 한명까지 함께 참석 가능하십니다. 참석여부 제출시에 파트너분 성함을 꼭 추가해주세요!",
  },
  "home.faq.question_4": {
    en: "Are kids welcome?",
    sk: "Môžem prísť s malými deťmi?",
    ko: "아이도 데려갈 수 있나요?",
  },
  "home.faq.answer_4": {
    en: "Wedding reception is adults only event, but if your childcare plans fall through, let us know and we will try to accommodate you.",
    sk: `Svadobná hostina a párty je hlavne pre dospelých, ale ak nemáte možnosť deti u niekoho nechať na stráženie, napište nám a niečo spolu vymyslíme.`,
    ko: "피로연 파티는 어른들만을 위한 자리로 준비하고 있어요. 혹시 자녀 돌봄 계획에 차질이 생긴다면 연락주세요. 최대한 함께하실 수 있도록 도와드릴게요.",
  },
  "home.registry.title": {
    en: "Registry",
    sk: "Svadobné dary",
    ko: "Registry",
  },
  "home.registry.content": {
    en: "Your presence is the best gift—seriously, we mean it! But if you absolutely insist, keep it small enough to fit in a carry-on.",
    sk: "Vaša účasť je pre nás ten najlepší dar—myslíme to vážne! Ale ak na tom trváte, prineste niečo malé, čo sa zmestí do príručnej batožiny.",
    ko: "먼걸음 하실 수 있는 분들께는 자리를 빛내주시는 것만으로도 저희에게는 큰 선물이고, 함께하지 못하시는 분들께는 이렇게 식을 멀리해서 죄송할 따름입니다. 그래서 저희의 새로운 시작을 함께 축하해주시는 마음만 감사히 받겠습니다!",
  },
  "login.title": {
    en: "Enter passcode provided with your invitation",
    sk: "Zadaj váš kód, ktorý ste dostali s pozvánkou.",
    ko: "청첩장에 표기된 비밀번호를 입력해주세요.",
  },
  "login.accessToken": {
    en: "Your passcode",
    sk: "Váš kód",
    ko: "비밀번호",
  },
  "login.signin": {
    en: "Sign in",
    sk: "Prihlásiť sa",
    ko: "로그인",
  },
  "rsvp.respondingFor": {
    en: "Responding for",
    sk: "Odpovedá",
    ko: "주 참석자 성함: ",
  },
  "rsvp.step1": {
    en: "Will you be able to join us at our wedding? Kindly reply by the date of June 1, 2025.",
    sk: "Budeš sa k nám môcť pridať na našej svadbe? Odpovedz prosím do 1. júna 2025.",
    ko: "저희 결혼식에 참석 가능하신가요? 2025년 6월 1일까지 참석여부 제출해 주시면 감사하겠습니다.",
  },
  "rsvp.step2": {
    en: "Your dietary restrictions",
    sk: "Tvoje stravovacie obmedzenia",
    ko: "음식에 알르레기나 제한 사항이 있으신가요?",
  },
  "rsvp.step3": {
    en: "Are you from Korea?",
    sk: "Si z Kórei?",
    ko: "한국인이신가요?",
  },
  "rsvp.step3.description": {
    en: "If yes, please enter your full name in Latin alphabet :) For example, 양보원 in Latin is Bowon Yang.",
    sk: "Ak áno, zadaj svoje celé meno v latinskej abecede :) Napríklad 양보원 v latinčine je Bowon Yang.",
    ko: "그렇다면 성함을 로마자로 표기해주세요. 예를 들면, 양보원은 Bowon Yang으로 표기가능합니다.",
  },
  "rsvp.step4": {
    en: "Your partner",
    sk: "Tvoj(a) partner(ka)",
    ko: "함께 참석하시는 파트너",
  },
  "rsvp.step5": {
    en: "Your partner's dietary restrictions",
    sk: "Stravovacie obmedzenia tvojej partnerky/tvojho partnera",
    ko: "음식에 알르레기나 제한 사항이 있으신가요?",
  },
  "rsvp.step6": {
    en: "Accomodation",
    sk: "Ubytovanie",
    ko: "숙박",
  },
  "rsvp.step6.description": {
    en: (
      <>
        Of all the places you could travel to, you chose us—and for that, we are
        very grateful. As a token of our appreciation, we’ve got a cozy little
        room waiting for you free of cost at&nbsp;
        <a
          href="https://penzionstrachan.sk/en/"
          className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
          target="_blank"
        >
          Penzion Strachan
        </a>
        , just steps away from our wedding venue. It’s all set for four
        nights—check-in at 4 PM on Thursday, July 10, and check-out at 11 AM on
        Monday, July 14. We’ll all be staying there, so expect some fun,
        possibly questionable decisions, and maybe even a group breakfast or
        two. 😆 Shall we lock this in for you?
      </>
    ),
    sk: (
      <>
        Zo všetkých miest, kam ste mohli ísť, ste si vybrali nás, za čo sme vám
        veľmi vďační. Ako prejav našej vďaky na vás čaká zdarma útulná izba
        v&nbsp;
        <a
          href="https://penzionstrachan.sk"
          className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
          target="_blank"
        >
          Penzióne Strachan
        </a>
        , len pár krokov od miesta svadby. Izba je pripravená na 4 noci—check-in
        o 16:00 vo štvrtok 10. júla a check-out o 11:00 v pondelok 14. júla.
        Budete tam s nami, takže sa tešte na srandu, pochybné rozhodnutia, a
        možno aj zopár raňajok a obedov v skupine 😆 Máte o izbu záujem?
      </>
    ),
    ko: (
      <>
        세상 많은 곳 중에 저희 결혼식을 위해 먼 곳까지 와주셔서 진심으로
        감사드립니다. 감사의 표시로 결혼식장 바로 건너편에 위치한 작지만
        편안한&nbsp;
        <a
          href="https://penzionstrachan.sk/en/"
          className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
          target="_blank"
        >
          스트라한 호텔
        </a>
        에서 숙박을 제공하고자 합니다. 목요일부터 월요일까지 4박이고 아침식사
        포함입니다. 7월 10일 목요일 오후 4부터 체크인 가능하며 7월 14일 월요일
        오전 11시까지 체크아웃입니다. 저희도 스트라한 호텔에서 머물 예정이니
        함께 커피와 아침식사도 하면서 재미있는 시간 보냅시다 😆 숙박을
        제공해드릴까요?
      </>
    ),
  },
  "rsvp.step7": {
    en: "Your email",
    sk: "Tvoj email",
    ko: "이메일",
  },
  "rsvp.step7.description": {
    en: "Add your email to receive future updates about the event.",
    sk: "Zadaj tvoj email, kde ťa môžme kontaktovať o prípadných zmenách.",
    ko: "결혼식에 관한 업데이트를 수신할 이메일 주소를 알려주세요.",
  },
  "rsvp.dietaryPreference.none": {
    en: "None",
    sk: "Žiadne",
    ko: "없음",
  },
  "rsvp.dietaryPreference.vegetarian": {
    en: "Vegetarian",
    sk: "Vegetarián",
    ko: "락토오보 채식",
  },
  "rsvp.dietaryPreference.vegan": {
    en: "Vegan",
    sk: "Vegán",
    ko: "비건 채식",
  },
  "rsvp.dietaryPreference.other": {
    en: "Other (please explain below)",
    sk: "Iné (upresni nižšie)",
    ko: "기타 (아래에 작성해주세요)",
  },
  "rsvp.dietaryExtra": {
    en: "Food allergies and other preferences",
    sk: "Potravinové alergie a iné preferencie",
    ko: "알르레기 및 기타",
  },
  "rsvp.firstName": {
    en: "First name",
    sk: "Krstné meno",
    ko: "이름",
  },
  "rsvp.lastName": {
    en: "Last name",
    sk: "Priezvisko",
    ko: "성",
  },
  "rsvp.nametag": {
    en: "Full name in Latin",
    sk: "Meno a priezvisko v latinskej abecede",
    ko: "성함을 로마자로 표기해주세요",
  },
  "rsvp.email": {
    en: "Your email",
    sk: "Tvoj email",
    ko: "이메일",
  },
  "rsvp.hasParner": {
    en: "I will be joined by my partner.",
    sk: "Prídem s partnerkou/partnerom.",
    ko: "파트너와 함께 참석할 예정입니다.",
  },
  "rsvp.saveResponse": {
    en: "Save response",
    sk: "Odoslať odpoveď",
    ko: "저장",
  },
  yes: {
    en: "Yes",
    sk: "Áno",
    ko: "네",
  },
  no: {
    en: "No",
    sk: "Nie",
    ko: "아니요",
  },
  accept: {
    en: "Accept",
    sk: "Mám záujem",
    ko: "네.",
  },
  decline: {
    en: "Decline",
    sk: "Nemám záujem",
    ko: "아니요.",
  },

  // errors
  [errors.badRequestData]: {
    en: "Unexpected error, please try again later.",
    sk: "Neočakávaná chyba, skús prosím neskôr.",
    ko: "서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
  },
  [errors.internalError]: {
    en: "Unexpected error, please try again later.",
    sk: "Neočakávaná chyba, skús prosím neskôr.",
    ko: "서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
  },
  [errors.unauthenticated]: {
    en: "Please provide your passcode.",
    sk: "Prosím zadaj prístupový kód.",
    ko: "비밀번호를 입력해주세요.",
  },
  [errors.unauthorized]: {
    en: "This passcode is invalid, please provide a different one.",
    sk: "Tento kód je neplatný, skús iný.",
    ko: "입력된 비밀번호에 오류가 있습니다. 비밀 번호를 재확인후 다시 입력해주세요.",
  },
  [errors.schemaError]: {
    en: "Unexpected error, please try again later.",
    sk: "Neočakávaná chyba, skús prosím neskôr.",
    ko: "서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
  },
  [errors.required]: {
    en: "Required.",
    sk: "Povinné.",
    ko: "필수사항.",
  },
  [errors.max50]: {
    en: "Maximum 50 characters.",
    sk: "Najviac 50 znakov.",
    ko: "최대 50자 입력 가능.",
  },
  [errors.max100]: {
    en: "Maximum 100 characters.",
    sk: "Najviac 100 znakov.",
    ko: "최대 100자 입력 가능.",
  },
  [errors.max1000]: {
    en: "Maximum 1000 characters.",
    sk: "Najviac 1000 znakov.",
    ko: "최대 1000자 입력 가능.",
  },
  [errors.validationEmail]: {
    en: "Must be email.",
    sk: "Musí byť email.",
    ko: "이메일 주소 형식을 확인해주세요.",
  },
  [errors.validationGeneric]: {
    en: "Invalid value.",
    sk: "Nepovolená hodnota.",
    ko: "입력하신 값이 올바르지 않습니다.",
  },
} as const satisfies Translations;

export type TranslationKeys = keyof typeof translations;
